/*import React, { useState, useEffect } from 'react';
import './eventpopup.css';*/

const EventPopup = () => {
 /* const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show popup when website opens
    setIsVisible(true);
  }, []);

  const closePopup = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="popup-overlay" onClick={closePopup}>
      <div className="popup-container" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close-btn" onClick={closePopup}>
          &times;
        </button>
        <img
          src="/events/demytifying1.jpeg"  // Change this to your image path
          alt="Event Banner"
          className="popup-image"
        />
      </div>
    </div>
  );*/
};

export default EventPopup;